<template>
  <modal name="add-brand-modal" @before-open="beforeOpen" transition="pop-out" :width="400" :height="350">
    <h4 class="text-center panel-heading">{{brand.id ? 'Merk aanpassen' : 'Merk toevoegen' }}</h4>
    <form @submit.prevent="handleSubmit()">
      <div class="col-sm-12 mb-20">
        <label>Website URL</label>
        <input type="url"
               class="form-control"
               placeholder="http://www.brabanttools.nl"
               v-model="brand.url">
      </div>
      <div class="col-sm-12 mb-20">
        <label>Tonen in banner?</label>
        <input type="checkbox"
               style="display:block"
               v-model="brand.shouldShowInHeader">
      </div>
      <div class="col-sm-12 mb-20">
        <label>Afbeelding (150 x 150)</label>
        <input type="file"
               @change="upload($event.target.files)" accept="image/*">
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div class="col-sm-4">
            <button type="submit" class="btn btn-danger">Opslaan</button>
          </div>
        </div>
      </div>
    </form>
  </modal>
</template>
<script>
  import {mapGetters} from 'vuex'
  import * as types from '../../store/mutation-types'

  export default {
    name: 'AddBrand',
    data () {
      return {
        modalHeight: 300,
        brand: {
          categoryId: null,
          url: '',
          shouldShowInHeader: false,
          imageLocation: ''
        },
        file: null
      }
    },
    methods: {
      handleSubmit () {
        this.brand.id ? this.editBrand() : this.addBrand()
      },
      addBrand () {
        this.$store.commit(types.SET_BRAND_TO_CREATE, this.brand)
        this.$store.dispatch('createBrand').then(() => {
          if (this.isBrandCreated) {
            this.brand.categoryId = null
            this.brand.shouldShowInHeader = false
            this.brand.imageLocation = ''
            this.brand.url = ''

            this.$modal.hide('add-brand-modal')
          } else {
            this.$notify({group: 'danger', type: 'error', title: 'Error', text: 'Kan dit merk niet aanmaken, probeer het later opnieuw!'})
          }
        })
      },
      editBrand () {
        this.$store.commit(types.SET_BRAND_TO_EDIT, this.brand)
        this.$store.dispatch('editBrand').then(() => {
          if (this.isBrandEdited) {
            this.brand.categoryId = null
            this.brand.shouldShowInHeader = false
            this.brand.imageLocation = ''
            this.brand.url = ''

            this.$modal.hide('add-brand-modal')
          } else {
            this.$notify({group: 'danger', type: 'error', title: 'Error', text: 'Kan dit merk niet aanpassen, probeer het later opnieuw!'})
          }
        })
      },
      beforeOpen (event) {
        if (event.params.categoryId) {
          this.brand.categoryId = event.params.categoryId
        } else if (event.params.brand) {
          this.brand = event.params.brand
        }
      },
      upload (image) {
        let data = new FormData()
        if (image !== '') {
          this.file = image.item(0)
          data.append('images', this.file, this.file.name)

          this.$store.dispatch('uploadImage', data).then(() => {
            if (this.imageLocation) {
              this.brand.imageLocation = this.imageLocation
            } else {
              this.$notify({group: 'danger', type: 'error', title: 'Error', text: 'Kan deze afbeelding niet uploaden!'})
            }
          })
        }
      }
    },
    computed: {
      ...mapGetters({
        isBrandCreated: 'isBrandCreated',
        isBrandEdited: 'isBrandEdited',
        imageLocation: 'imageLocation'
      })
    }
  }
</script>

<style scoped>
  .mb-20 {
    margin-bottom: 20px;
  }
</style>
